import Vue from 'vue'
import Router from 'vue-router'
import Store from './stores'
import ls from 'localstorage-slim'
import CryptoJS from 'crypto-js'

import NotFound from './views/NotFound.vue'
import Expired from './views/Expired.vue'
import Login from './views/Login.vue'
import Page from './views/Page.vue'
import Coupon from './views/Coupon.vue'
import Cart from './views/Cart.vue'
import Amenity from './views/Amenity.vue'
import Product from './views/Product.vue'
import Reservation from './views/Reservation.vue'
import Mypage from './views/Mypage.vue'
import RoomCharge from './components/Mypage/RoomCharge.vue'
import Payment from './views/Payment.vue'
import SeparatePayment from './components/Payment/Separate.vue'
import ReservationList from './components/Mypage/ReservationList.vue'
import OrderList from './components/Mypage/OrderList.vue'
import PaymentList from './components/Mypage/PaymentList.vue'
import PaymentItem from './components/Mypage/PaymentItemPage.vue'
import PaymentReceipt from './components/Mypage/PaymentReceipt.vue'
import PaymentStep from './components/Payment/Step.vue'
import ReservationComplete from './components/Reservation/Complete.vue'
import CheckReservation from './components/Reservation/Check.vue'
import TvControl from './views/TvControl.vue'
import LocalInfo from './views/LocalInfo.vue'
import LocalView from './components/LocalInfo/LocalView.vue'
import LocalList from './components/LocalInfo/LocalList.vue'
import Control from './views/Control.vue'
import FlightInfo from './views/FlightInfo.vue'
import FlightSchedule from './components/FlightInfo/FlightSchedule.vue'
import Complete from './views/Complete.vue'
import ImageViewer from './components/Util/ImageViewer.vue'
import Checkout from './views/Checkout.vue'
import Morningcall from './views/Morningcall.vue'
import Parking from './views/Parking.vue'
import Mobility from './views/Mobility.vue'
import MyMobility from './components/Maps/My.vue'
import SuperAdmin from './views/SuperAdmin.vue'
import Mobilekey from './views/Mobilekey.vue'
import MobilekeyAuth from './components/Mobilekey/Auth.vue'
import MobilekeyView from './components/Mobilekey/View.vue'
import Waitingcall from './views/Waitingcall.vue'
import WaitingcallDisabled from './components/Waitingcall/Disabled.vue'
import WaitingcallNationality from './components/Waitingcall/Nationality.vue'
import WaitingcallAuth from './components/Waitingcall/Auth.vue'
// import WaitingcallApply from './components/Waitingcall/Apply.vue'
import WaitingcallResult from './components/Waitingcall/Result.vue'
import WaitingcallStatus from './components/Waitingcall/Status.vue'
import Mypackage from './views/Mypackage.vue'
import MyTicket from './components/Mypage/TicketList.vue'
import MyTicketDetail from './components/Mypage/TicketDetail.vue'

import Shop from './views/Shop.vue'

import Collection from './views/Collection.vue'
import CollectionPageDefault from './components/Collection/PageDefault.vue'
import CollectionCover from './components/Collection/Cover.vue'
import CollectionPage from './components/Collection/Page.vue'
import CollectionCategoryMain from './components/Collection/CategoryMain.vue'
import CollectionDetail from './components/Collection/CollectionDetail.vue'
import MyCollection from './components/Collection/MyCollection.vue'

ls.config.encrypt = true
ls.config.decrypt = true
ls.config.secret = 'istay-key-password'
ls.config.encrypter = (data, secret) => CryptoJS.AES.encrypt(JSON.stringify(data), secret).toString()
ls.config.decrypter = (data, secret) => {
  try {
    return JSON.parse(CryptoJS.AES.decrypt(data, secret).toString(CryptoJS.enc.Utf8))
  } catch (e) {
    // incorrect secret, return the encrypted data instead / or null
    return data // or return null;
  }
}

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: {
        name: 'main'
      }
    },
    {
      path: '/:ln/login',
      name: 'login',
      component: Login,
      props: true
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: NotFound,
      props: true
    },
    {
      path: '/expired',
      name: 'expired',
      props: true
    },
    {
      path: '/:ln/superadmin',
      name: 'superadmin',
      component: SuperAdmin,
      props: true
    },
    {
      path: '/:ln/complete',
      name: 'complete',
      component: Complete,
      props: true
    },
    {
      path: '/:ln',
      name: 'main',
      component: Page,
      props: true
    },
    {
      path: '/:ln/page/:id',
      name: 'page',
      component: Page,
      props: true
    },
    {
      path: '/:ln/coupon',
      name: 'coupon',
      component: Coupon,
      props: true
    },
    {
      path: '/:ln/cart',
      name: 'cart',
      component: Cart,
      props: true
    },
    {
      path: '/:ln/localinfo',
      name: 'localinfo',
      component: LocalInfo,
      meta: { translate: 'always' },
      props: true,
      children: [
        {
          path: ':type',
          name: 'filteredLocalinfo',
          component: LocalList,
          props: true
        },
        {
          path: ':type/:placeId',
          name: 'localview',
          component: LocalView,
          props: true
        }
      ]
    },
    {
      path: '/:ln/flightinfo',
      name: 'flightinfo',
      component: FlightInfo,
      meta: { translate: 'always' },
      props: true
    },
    {
      path: '/:ln/flightinfo/:airport/schedule',
      name: 'flightSchedule',
      component: FlightSchedule,
      meta: { translate: 'always' },
      props: true
    },
    {
      path: '/:ln/amenity',
      name: 'amenity',
      component: Amenity,
      props: true
    },
    {
      path: '/:ln/control',
      name: 'control',
      component: Control,
      props: true
    },
    {
      path: '/:ln/shop/:shopPageId?/:shopCategoryId?',
      name: 'shop',
      component: Shop,
      props: true
    },
    {
      path: '/:ln/store/:shopPageId?/:shopCategoryId?', // f&b 업장용
      name: 'store',
      component: Shop,
      props: true
    },
    {
      path: '/:ln/product/:productId',
      name: 'product',
      component: Product,
      props: true
    },
    {
      path: '/:ln/product/:productId/:category',
      name: 'productCategory',
      component: Product,
      props: true
    },
    {
      path: '/:ln/product/:productId/:detailId',
      name: 'productDetail',
      component: Product,
      props: true
    },
    {
      path: '/:ln/reservation/:reservationId',
      name: 'reservation',
      component: Reservation,
      props: true
    },
    {
      path: '/:ln/reservation/check/:reservationId',
      name: 'checkReservation',
      component: CheckReservation,
      props: true
    },
    {
      path: '/:ln/reservation/complete/:reservationId',
      name: 'reservationComplete',
      component: ReservationComplete,
      props: true
    },
    {
      path: '/:ln/mypage',
      name: 'mypage',
      component: Mypage,
      props: true
    },
    {
      path: '/:ln/roomCharge',
      name: 'roomCharge',
      component: RoomCharge,
      props: true
    },
    {
      path: '/:ln/payment',
      name: 'payment',
      component: Payment,
      props: true
    },
    {
      path: '/:ln/paymentstep',
      name: 'paymentStep',
      component: PaymentStep,
      props: true
    },
    {
      path: '/:ln/myOrder/:package?',
      name: 'myOrder',
      component: OrderList,
      props: true
    },
    {
      path: '/:ln/myReservation/:package?',
      name: 'myReservation',
      component: ReservationList,
      props: true
    },
    {
      path: '/:ln/myTicket/:package(package)?',
      name: 'myTicket',
      component: MyTicket,
      props: true
    },
    {
      path: '/:ln/myTicket/:package(package)?/:guestTicketId',
      name: 'myTicketDetail',
      component: MyTicketDetail,
      props: true
    },
    {
      path: '/:ln/myPayment',
      name: 'myPayment',
      component: PaymentList,
      props: true
    },
    {
      path: '/:ln/myPayment/:orderId',
      name: 'myPaymentItem',
      component: PaymentItem,
      props: true
    },
    {
      path: '/:ln/payment/separate/:pg/:pgid',
      name: 'separatePayment',
      component: SeparatePayment,
      props: true
    },
    {
      path: '/:ln/myPayment/receipt/:orderId',
      name: 'paymentReceipt',
      component: PaymentReceipt,
      props: true
    },
    {
      path: '/:ln/tv',
      name: 'tv',
      component: TvControl,
      props: true
    },
    {
      path: '/:ln/imageViewer/:src',
      name: 'imageViewer',
      component: ImageViewer,
      meta: { changeNav: true },
      props: true
    },
    {
      path: '/:ln/checkout',
      name: 'checkout',
      component: Checkout,
      props: true
    },
    {
      path: '/:ln/morningcall',
      name: 'morningcall',
      component: Morningcall,
      props: true
    },
    {
      path: '/:ln/parking',
      name: 'parking',
      component: Parking,
      props: true
    },
    {
      path: '/:ln/mobility',
      name: 'mobility',
      component: Mobility,
      props: true
    },
    {
      path: '/:ln/mobility/my',
      name: 'myMobility',
      component: MyMobility,
      props: true
    },
    {
      path: '/:ln/mobilekey',
      name: 'mobilekey',
      component: Mobilekey,
      props: true,
      redirect: {
        name: 'mobilekeyAuth'
      },
      children: [
        {
          path: 'auth',
          name: 'mobilekeyAuth',
          component: MobilekeyAuth,
          props: true
        },
        {
          path: 'view',
          name: 'mobilekeyView',
          component: MobilekeyView,
          props: true
        }
      ]
    },
    {
      path: '/:ln/waitingcall',
      name: 'waitingcall',
      component: Waitingcall,
      props: true,
      redirect: {
        name: 'waitingcallNationality'
      },
      children: [
        {
          path: 'disabled',
          name: 'waitingcallDisabled',
          component: WaitingcallDisabled,
          props: true
        },
        {
          path: 'nationality',
          name: 'waitingcallNationality',
          component: WaitingcallNationality,
          props: true
        },
        {
          path: 'auth/:nationality',
          name: 'waitingcallAuth',
          component: WaitingcallAuth,
          props: true
        },
        // {
        //   path: 'apply',
        //   name: 'waitingcallApply',
        //   component: WaitingcallApply,
        //   props: true
        // },
        {
          path: 'result/:rid',
          name: 'waitingcallResult',
          component: WaitingcallResult,
          props: true
        },
        {
          path: 'status/:rid',
          name: 'waitingcallStatus',
          component: WaitingcallStatus,
          props: true
        }
      ]
    },
    {
      path: '/:ln/mypackage',
      name: 'mypackage',
      component: Mypackage,
      props: true
    },
    {
      path: '/error/:reason',
      name: 'error',
      props: true
    },
    {
      path: '/:ln/collection',
      name: 'collection',
      component: Collection,
      props: true,
      children: [
        {
          path: ':pageId',
          name: 'collectionPageDefault',
          component: CollectionPageDefault,
          props: true
        },
        {
          path: ':pageId/cover',
          name: 'collectionCover',
          component: CollectionCover,
          props: true
        },
        {
          path: ':pageId/intro',
          name: 'collectionIntro',
          component: CollectionPage,
          props: true
        },
        {
          path: ':pageId/main',
          name: 'collectionMain',
          component: CollectionPage,
          props: true
        },
        {
          path: ':pageId/:categoryId/main',
          name: 'collectionCategoryMain',
          component: CollectionCategoryMain,
          props: true
        },
        {
          path: ':pageId/myCollection/:categoryId?',
          name: 'myCollection',
          component: MyCollection,
          props: true
        },
        {
          path: ':pageId/:categoryId/:collectionItemId',
          name: 'collectionDetail',
          component: CollectionDetail,
          props: true
        },
        {
          path: ':pageId/:categoryId',
          name: 'collectionPage',
          component: CollectionPage,
          props: true
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    const sameShopPage = from.name === 'shop' && to.name === 'shop' && from.params.shopPageId === to.params.shopPageId
    const sameStorePage = from.name === 'store' && to.name === 'store' && from.params.shopPageId === to.params.shopPageId
    const scrollRoute = !(to.name && to.name.includes('product')) && !sameShopPage && !sameStorePage
    if (scrollRoute) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (savedPosition) {
            resolve({ x: 0, y: windowScrollY })
          } else {
            resolve({ x: 0, y: 0 })
          }
        }, 500)
      })
    }
  }
})

export default router

let popState = false
window.onpopstate = function (e) {
  popState = true
}

const isAuth = async () => {
  const siteInfo = getUrlParams()
  const site = siteInfo.site
  // const otaKey = window.location.hostname !== 'localhost' && siteInfo.k
  const space = siteInfo.space
  const otaKey = siteInfo.k
  const isAuth = typeof (site) !== 'undefined' && site !== ''
  const updateParams = function () {
    const deleteParam = /lang|bkey|messenger|best|metakey|gv/ // 불필요한 파라미터
    siteInfo.otavalid = 'false'
    Store.state.authentication.otavalid = 'false'
    return Object.keys(siteInfo).filter(key => !deleteParam.test(key)).map(key => `${key}=${siteInfo[key]}`).join('&')
  }
  function getUrlParams () {
    const params = Object.fromEntries(new URLSearchParams(window.location.search))
    Store.dispatch('authentication/setAuthInfo', params)
    return params
  }
  if (otaKey) {
    Store.dispatch('authentication/validateOtaKey', {otaKey: otaKey, space: space}).then((res) => {
      if (!res) {
        history.replaceState({}, null, `${location.origin}${location.pathname}?${updateParams()}${location.hash}`)
      }
    })
  }
  return isAuth
}

const clearPaymentParams = () => {
  const siteInfo = getUrlParams()
  const updateParams = function () {
    const deleteParam = /commerce|orderId|orderStatus|orderReason/ // 결제완료 페이지 이후 불필요한 파라미터
    return {
      deleteParams: Object.keys(siteInfo).filter(key => deleteParam.test(key)),
      params: Object.keys(siteInfo).filter(key => !deleteParam.test(key)).map(key => `${key}=${siteInfo[key]}`).join('&')
    }
  }
  function getUrlParams () {
    const params = Object.fromEntries(new URLSearchParams(window.location.search))
    return params
  }
  if (updateParams().deleteParams && updateParams().deleteParams.length > 0) {
    history.pushState({}, null, `${location.origin}${location.pathname}?${updateParams().params}${location.hash}`)
  }
}

let windowScrollY = 0
let previousRoute = null
router.beforeEach(async (to, from, next) => {
  if (!popState) {
    windowScrollY = window.scrollY
  }
  previousRoute = from
  popState = false
  if (to.name !== 'notfound') {
    if (isAuth()) {
      if (!['error'].includes(to.name)) {
        Store.commit('system/setLastRoute', to.fullPath)
      }
      if (from && from.name) {
        clearPaymentParams()
        next()
      } else {
        next()
      }
    } else {
      console.log('Invalid access has been detected.')
      next({
        name: 'notfound'
      })
    }
  } else {
    next()
  }
})

export function getPreviousRoute() {
  return previousRoute
}
